module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container",
    class: {
      'white': _vm.$route.meta.noSession, 'fullscreen': _vm.$route.meta.fullscreen, 'tbc-mode': _vm.tbcMode
    }
  }, [(!_vm.tbcMode && !_vm.embedMode) ? _c('headbar') : _vm._e(), _vm._v(" "), (!_vm.$route.meta.noSession && !_vm.embedMode && !_vm.tbcMode) ? _c('hintbox') : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-container"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f44540c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 917
// module chunks = 3